import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheOptimizationPulse from "./sections/TheOptimizationPulse";
import LatestIntelligence from "./sections/LatestIntelligence";
import MetricIntelligenceHub from "./sections/MetricIntelligenceHub";
import ExpertPerspectives from "./sections/ExpertPerspectives";
import TheSpeedLabPreview from "./sections/TheSpeedLabPreview";
import JoinThePerformanceNetwork from "./sections/JoinThePerformanceNetwork";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheOptimizationPulse />
      <LatestIntelligence />
      <MetricIntelligenceHub />
      <ExpertPerspectives />
      <TheSpeedLabPreview />
      <JoinThePerformanceNetwork />
      <Footer />
    </div>;
}